(() => {
  const toInt = (value, fallback) => {
    const n = parseInt(value, 10);
    return Number.isFinite(n) ? n : fallback;
  };

  const moneyFormat = (cents) => {
    if (window.theme?.Shopify?.formatMoney) {
      return window.theme.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    return `$${(cents / 100).toFixed(2)}`;
  };

  const parseMoneyFromTitle = (title) => {
    if (!title) return '';
    const match = String(title).match(/\$\s*([0-9]+(?:\.[0-9]{2})?)/);
    if (!match) return '';
    return `$${match[1]}`;
  };

  const init = (root) => {
    if (!root || root.__wiggliesBundleInit) return;
    root.__wiggliesBundleInit = true;

    const tierButtons = Array.from(root.querySelectorAll('[data-tier]'));
    const priceEl = root.querySelector('[data-bundle-price]');
    const selectedCountEl = root.querySelector('[data-selected-count]');
    const selectedLimitEl = root.querySelector('[data-selected-limit]');

    const form = root.querySelector('[data-bundle-form]');
    const submitBtn = root.querySelector('[data-submit]');
    const bundleVariantInput = root.querySelector('[data-bundle-variant-id]');
    const propBundleSize = root.querySelector('[data-prop-bundle-size]');
    const propBundleItems = root.querySelector('[data-prop-bundle-items]');

    const attrInt = (name, fallback) => toInt(root.getAttribute(name), fallback);

    const tierSizes = {
      1: attrInt('data-tier-1-size', 6),
      2: attrInt('data-tier-2-size', 15),
      3: attrInt('data-tier-3-size', 30),
      4: attrInt('data-tier-4-size', 50)
    };

    const tierVariantIds = {
      1: attrInt('data-tier-1-variant-id', 0),
      2: attrInt('data-tier-2-variant-id', 0),
      3: attrInt('data-tier-3-variant-id', 0),
      4: attrInt('data-tier-4-variant-id', 0)
    };

    const tierPrices = {
      1: attrInt('data-tier-1-price', 0),
      2: attrInt('data-tier-2-price', 0),
      3: attrInt('data-tier-3-price', 0),
      4: attrInt('data-tier-4-price', 0)
    };

    let activeTier = 1;

    const getChoices = () => Array.from(root.querySelectorAll('[data-choice]'));

    const parseQty = (input) => {
      const v = parseInt(input?.value, 10);
      return Number.isFinite(v) && v > 0 ? v : 0;
    };

    const totalSelected = () => {
      return getChoices().reduce((acc, el) => {
        const qtyInput = el.querySelector('[data-qty]');
        return acc + parseQty(qtyInput);
      }, 0);
    };

    const clampToTierLimit = () => {
      const limit = tierSizes[activeTier];
      const count = totalSelected();
      if (count <= limit) return;

      let remainingToRemove = count - limit;
      const choices = getChoices();

      for (let i = choices.length - 1; i >= 0 && remainingToRemove > 0; i--) {
        const qtyInput = choices[i].querySelector('[data-qty]');
        let q = parseQty(qtyInput);
        if (q === 0) continue;

        const remove = Math.min(q, remainingToRemove);
        q -= remove;
        remainingToRemove -= remove;
        qtyInput.value = String(q);
      }
    };

    const buildBundleItemsValue = () => {
      const items = [];
      getChoices().forEach((el) => {
        const qtyInput = el.querySelector('[data-qty]');
        const qty = parseQty(qtyInput);
        if (!qty) return;

        const title = el.dataset.productTitle || '';
        items.push(`${title} x${qty}`);
      });
      return items.join(', ');
    };

    const updateTierButtons = async () => {
      const tiers = [1, 2, 3, 4];

      for (const t of tiers) {
        const btn = root.querySelector(`[data-tier="${t}"]`);
        if (!btn) continue;

        const variantId = tierVariantIds[t];
        const size = tierSizes[t];

        let priceText = '';

        if (tierPrices[t]) {
          priceText = moneyFormat(tierPrices[t]);
          if (t === activeTier && priceEl) priceEl.textContent = priceText;
        }

        if (variantId) {
          try {
            const resp = await fetch(`/variants/${variantId}.js`, { credentials: 'same-origin' });
            if (resp.ok) {
              const variant = await resp.json();

              if (!priceText && Number.isFinite(variant?.price)) {
                priceText = moneyFormat(variant.price);
              }
              if (!priceText && variant?.title) {
                priceText = parseMoneyFromTitle(variant.title);
              }
              if (t === activeTier && priceEl && priceText) priceEl.textContent = priceText;
            }
          } catch (e) {}
        }

        if (priceText) {
          btn.textContent = `${size} Wigglies - ${priceText}`;
        } else {
          btn.textContent = `${size} Wigglies`;
        }
      }
    };

    const updateUI = () => {
      const count = totalSelected();
      if (selectedCountEl) selectedCountEl.textContent = String(count);
      if (selectedLimitEl) selectedLimitEl.textContent = String(tierSizes[activeTier]);

      const limit = tierSizes[activeTier];
      const isComplete = count === limit;

      if (submitBtn) submitBtn.disabled = !isComplete;

      if (propBundleItems) {
        propBundleItems.value = buildBundleItemsValue();
      }
    };

    const setTier = (tier, silent = false) => {
      if (!tierSizes[tier]) return;
      activeTier = tier;

      tierButtons.forEach((btn) => {
        const t = parseInt(btn.dataset.tier, 10);
        if (t === activeTier) {
          btn.classList.add('btn--primary');
          btn.classList.remove('btn--secondary');
        } else {
          btn.classList.remove('btn--primary');
          btn.classList.add('btn--secondary');
        }
      });

      if (bundleVariantInput && tierVariantIds[activeTier]) {
        bundleVariantInput.value = String(tierVariantIds[activeTier]);
      }
      if (propBundleSize) propBundleSize.value = String(tierSizes[activeTier]);
      if (selectedLimitEl) selectedLimitEl.textContent = String(tierSizes[activeTier]);

      clampToTierLimit();
      updateTierButtons();
      updateUI();

      void silent;
    };

    const normalizeTierByCount = () => {
      const count = totalSelected();
      if (count > tierSizes[3]) {
        setTier(4, true);
      } else if (count > tierSizes[2]) {
        setTier(3, true);
      } else if (count > tierSizes[1]) {
        setTier(2, true);
      } else {
        setTier(1, true);
      }
    };

    tierButtons.forEach((btn) => {
      btn.classList.add('btn--secondary');
      btn.addEventListener('click', () => {
        const t = parseInt(btn.dataset.tier, 10);
        setTier(t);
      });
    });

    getChoices().forEach((choice) => {
      const qtyInput = choice.querySelector('[data-qty]');
      const incBtn = choice.querySelector('[data-increment]');
      const decBtn = choice.querySelector('[data-decrement]');

      const setQty = (q) => {
        const currentTotal = totalSelected();
        const current = parseQty(qtyInput);
        const delta = q - current;
        const nextTotal = currentTotal + delta;

        if (nextTotal < 0) {
          qtyInput.value = '0';
        } else if (nextTotal > tierSizes[4]) {
          qtyInput.value = String(current);
        } else {
          qtyInput.value = String(Math.max(0, q));
        }

        normalizeTierByCount();

        const newLimit = tierSizes[activeTier];
        if (totalSelected() > newLimit) {
          clampToTierLimit();
        }

        updateUI();
      };

      if (incBtn) {
        incBtn.addEventListener('click', () => setQty(parseQty(qtyInput) + 1));
      }
      if (decBtn) {
        decBtn.addEventListener('click', () => setQty(parseQty(qtyInput) - 1));
      }
      if (qtyInput) {
        qtyInput.addEventListener('change', () => setQty(parseQty(qtyInput)));
      }
    });

    if (form) {
      form.addEventListener('submit', () => {
        if (propBundleSize) propBundleSize.value = String(tierSizes[activeTier]);
        if (bundleVariantInput) bundleVariantInput.value = String(tierVariantIds[activeTier]);
        if (propBundleItems) propBundleItems.value = buildBundleItemsValue();
      });
    }

    setTier(1, true);
  };

  document.addEventListener('DOMContentLoaded', () => {
    document
      .querySelectorAll('[data-section-type="wigglies-bundle-builder"] .wigglies-bundle')
      .forEach((el) => init(el));
  });
})();